/**
 * Add a scroll anchor to each pagination link
 */

// Get pagination on the page
const pagination = document.querySelector(".archive__pagination");

// If a pagination exists on the page
if (pagination) {
    // Get all nav links
    const links = pagination.querySelectorAll("a.page-numbers");

    // Loop through nav links and modify their `href` value
    links.forEach(link => {
        link.href = link.href + '#posts'; // add the '#posts' to the href value
    });
}


/**
 * Toggle function for searchs on mobile
 */
const searchToggle = document.querySelector("#archive-search-toggle");
const searchForm = document.querySelector("#archive-search-form");
const searchFormToggledClass = "archive-search-form-toggled";

if (searchForm && searchToggle) {
    searchToggle.addEventListener("click", () => {
        if (document.body.classList.contains(searchFormToggledClass)) {
            searchForm.style.maxHeight = "0";
            document.body.classList.remove(searchFormToggledClass);
        } else {
            searchForm.style.maxHeight = `${searchForm.scrollHeight}px`;
            document.body.classList.add(searchFormToggledClass);
        }
    });
}